import { Component, Input, OnInit, Output, EventEmitter, signal, computed, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AmbassadorProgramCompanyVehicleService } from '../../../../services/ambassador-program-company-vehicle.service';
import { AmbassadorProgramCompanyVehicleDTO } from '../../../../models/ambassador-program-company-vehicle-dto';
import { AmbassadorProgramCompanyVehicleScheduleService } from '../../../../services/ambassador-program-company-vehicle-schedule.service';
import { AmbassadorProgramCompanyVehicleScheduleDTO } from '../../../../models/ambassador-program-company-vehicle-schedule-dto';
import { AmbassadorProgramCompanyService } from '../../../../services/ambassador-program-company.service';
import { AmbassadorProgramCompanyDTO } from '../../../../models/ambassador-program-company-dto';
import Swal from 'sweetalert2';

@Component({
    selector: 'ambassador-calendar-summary',
  standalone: true,
  templateUrl: './ambassador-calendar-summary.component.html',
  styleUrls: ['./ambassador-calendar-summary.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule]
})

export class AmbassadorCalendarSummaryComponent implements OnInit {

    @Input() idSchedule: string;
    @Input() timePreference: string;
    @Input() idVehicle: string;
    @Input() showActions: boolean = true;
    @Output() backToCalendar = new EventEmitter<void>();
    @Output() confirmReservation = new EventEmitter<void>();

    vehicle = signal<AmbassadorProgramCompanyVehicleDTO | null>(null);
    schedule = signal<AmbassadorProgramCompanyVehicleScheduleDTO | null>(null);
    company = signal<AmbassadorProgramCompanyDTO | null>(null);

    readonly months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                     'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

    deliveryAddressHtml = computed<SafeHtml>(() => {
        const companyData = this.company();
        if (companyData?.DeliveryAddress) {
            return this.sanitizer.bypassSecurityTrustHtml(companyData.DeliveryAddress);
        }
        return null;
    });

    constructor(
        private vehicleService: AmbassadorProgramCompanyVehicleService,
        private scheduleService: AmbassadorProgramCompanyVehicleScheduleService,
        private companyService: AmbassadorProgramCompanyService,
        private sanitizer: DomSanitizer
    ) {
    }

    ngOnInit() {
        this.loadData();
        this.scrollToContent();
    }

    scrollToContent() {
        // Esperar a que el DOM esté completamente renderizado
        setTimeout(() => {
            const programLogoElement = document.querySelector('.program-logo');
            const topbarElement = document.querySelector('.topbar');

            if (programLogoElement) {
                const topbarHeight = topbarElement ? topbarElement.getBoundingClientRect().height : 0;
                const programLogoPosition = programLogoElement.getBoundingClientRect().top + window.pageYOffset;
                const scrollPosition = programLogoPosition - topbarHeight;

                window.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    }

    loadData() {
        // Cargar información del schedule
        if (this.idSchedule) {
            this.scheduleService.get(this.idSchedule).subscribe(
                (schedule) => {
                    this.schedule.set({
                        ...schedule,
                        ScheduledInitDate: new Date(schedule.ScheduledInitDate),
                        ScheduledEndDate: new Date(schedule.ScheduledEndDate)
                    });
                },
                (err) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar la información del horario',
                        customClass: {
                          popup: 'custom-swal-popup',
                          title: 'custom-swal-title',
                          htmlContainer: 'custom-swal-html',
                          cancelButton: 'custom-swal-cancel',
                          confirmButton: 'custom-swal-confirm',
                          icon: 'custom-swal-icon'
                        },
                        confirmButtonText: 'Cerrar <i class="fa-solid fa-xmark"></i>'
                    });
                }
            );
        }

        // Cargar información del vehículo
        if (this.idVehicle) {
            this.vehicleService.get(this.idVehicle).subscribe(
                (vehicle) => {
                    this.vehicle.set(vehicle);

                    this.companyService.get(this.vehicle().IdCompany).subscribe(
                        (company) => {
                            this.company.set(company);
                        },
                        (err) => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: 'Error al cargar la información de la compañía',
                                customClass: {
                                  popup: 'custom-swal-popup',
                                  title: 'custom-swal-title',
                                  htmlContainer: 'custom-swal-html',
                                  cancelButton: 'custom-swal-cancel',
                                  confirmButton: 'custom-swal-confirm',
                                  icon: 'custom-swal-icon'
                                },
                                confirmButtonText: 'Cerrar <i class="fa-solid fa-xmark"></i>'
                            });
                        }
                    );
                },
                (err) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar la información del vehículo',
                        customClass: {
                          popup: 'custom-swal-popup',
                          title: 'custom-swal-title',
                          htmlContainer: 'custom-swal-html',
                          cancelButton: 'custom-swal-cancel',
                          confirmButton: 'custom-swal-confirm',
                          icon: 'custom-swal-icon'
                        },
                        confirmButtonText: 'Cerrar <i class="fa-solid fa-xmark"></i>'
                    });
                }
            );
        }

        // Cargar información de la compañía
        // this.userService.getProgramCompanyUserData().subscribe(
        //     (user) => {
        //         if (user && user.IdCompany) {
                    // this.companyService.get(this.vehicle().IdCompany).subscribe(
                    //     (company) => {
                    //         this.company.set(company);
                    //     },
                    //     (err) => {
                    //         Swal.fire({
                    //             icon: 'error',
                    //             title: 'Error',
                    //             text: 'Error al cargar la información de la compañía'
                    //         });
                    //     }
                    // );
        //         }
        //     },
        //     (err) => {
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Error',
        //             text: 'Error al cargar la información del usuario'
        //         });
        //     }
        // );
    }

    formatDateRange(): string {
        const schedule = this.schedule();
        if (!schedule) return '';

        const startDate = new Date(schedule.ScheduledInitDate);
        const endDate = new Date(schedule.ScheduledEndDate);
        endDate.setDate(endDate.getDate() + 1);

        const startDay = startDate.getDate();
        const startMonth = this.months[startDate.getMonth()];
        const endDay = endDate.getDate();
        const endMonth = this.months[endDate.getMonth()];

        if (startMonth === endMonth) {
            return `del ${startDay} al ${endDay} de ${startMonth}`;
        } else {
            return `del ${startDay} de ${startMonth} al ${endDay} de ${endMonth}`;
        }
    }

    formatTimePreference(): string {
        if (!this.timePreference) return '9:00 - 10:00*';

        return this.timePreference + '*';
    }

    onConfirm() {
        this.confirmReservation.emit();
    }

    onBack() {
        this.backToCalendar.emit();
    }
}

